import type { PaymentItemId } from '../../../generated-types';
import { updatePayment } from '../../../services/paymentService';
import mapUpdatePaymentRequest from '../../FuturePayment/utils/mapUpdatePaymentRequest';
import { PaymentState } from '../Payment/form/state';

type PaymentStateWithPaymentItemId = {
    paymentId: PaymentItemId;
} & PaymentState;

export default () =>
    ({ paymentId, ...state }: PaymentStateWithPaymentItemId) => {
        const request = mapUpdatePaymentRequest(state);
        return updatePayment(paymentId, request);
    };
